import { useFormContext } from 'react-hook-form';
import { FlexCenterBoth, FlexCol } from 'components/primitives/flex';
import PageHeader from 'components/auth/components/PageHeader';
import Input from 'components/ui/Input/Input';
import ErrorMessage from 'components/ui/ErrorMessage/ErrorMessage';
import { Text } from 'components/primitives/typography';
import styled from 'styled-components';

interface Props {
  resendCode(): Promise<void>;
  headerText?: string;
  verificationText?: string;
  backClickLabel?: string;
  onBackClick?(): void;
  resendCodeDisabled?: boolean;
  resendCooldown?: number;
}

export default function VerificationInput({
  resendCode,
  headerText,
  verificationText,
  backClickLabel,
  resendCooldown,
  onBackClick,
  resendCodeDisabled = false,
}: Props) {
  const methods = useFormContext();
  const { watch, register, errors } = methods;

  return (
    <Wrapper>
      <FlexCol data-testid="component-auth-flow-code-verification-form" gap="20px">
        {headerText && <PageHeader title={headerText} backAction={onBackClick} />}
        <FlexCol gap="10px">
          <Text>{verificationText}</Text>
          <Input
            name="code"
            hasValue={!!watch('code')}
            hasError={!!errors.code}
            maxLength={6}
            autoComplete="one-time-code"
            inputRef={register({
              required: 'Please enter your verification code',
              minLength: {
                value: 6,
                message: 'SMS code has 6 numbers',
              },
            })}
            placeholder="6 digit code"
          />
          <ErrorMessage error={errors?.code} />
        </FlexCol>
        <FlexCenterBoth pt="10px">
          <button
            disabled={resendCodeDisabled}
            type="button"
            style={{ fontWeight: 500, color: resendCodeDisabled ? '#8E9697' : '#0751C2', cursor: 'pointer' }}
            onClick={resendCode}
          >
            {resendCodeDisabled ? `Resend code in ${resendCooldown}s` : 'Resend code'}
          </button>
          {onBackClick && backClickLabel && (
            <button type="button" onClick={onBackClick}>
              <Text ml="15px" pl="15px" borderLeft="1px solid #8E9697" fWeight={500} color="#0751C2" cursor="pointer">
                {backClickLabel}
              </Text>
            </button>
          )}
        </FlexCenterBoth>
      </FlexCol>
    </Wrapper>
  );
}

const Wrapper = styled(FlexCol)`
  [class*='Input_placeholder'] {
    width: 100%;
    left: 0;
    text-align: center;
  }
  input {
    text-align: center;
    text-indent: 10px;
    letter-spacing: 10px;
  }
`;
